import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class UserRolesResolve implements CanActivate, Resolve<boolean> {
  public currentUserWithACL = new BehaviorSubject(null);
  private hideLoader = false;

  constructor(private userService: UserService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> | boolean {
    return this.getCurrentUserWithACL().pipe(
      map((user) => {
        return user.Loans;
      })
    );
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.resolve(route);
  }

  /*
   * This method is used only if any gaurd is called before this resolver else data will be available in the Activated Route.
   * */
  public getCurrentUserWithACL(nmls?): Observable<any> {
    if (this.currentUserWithACL.getValue()) {
      return of(this.currentUserWithACL.getValue());
    } else {
      return this.userService.getCurrentUserWithAcl(this.hideLoader, nmls).pipe(
        map((userInfoMap) => {
          this.currentUserWithACL.next(userInfoMap);
          this.userService.updateUser(userInfoMap);
          this.hideLoader = false;
          return userInfoMap;
        })
      );
    }
  }

  /**
   * Method reset current user with acl
   */
  public resetCurrentUserWithACL(hideLoader?: boolean) {
    this.hideLoader = hideLoader;
    this.currentUserWithACL.next(null);
  }
}
